export class NoFallbackError extends Error {
    constructor(){
        super();
        this.message = 'Internal: NoFallbackError';
    }
}

//# sourceMappingURL=no-fallback-error.external.js.map